import { useToast } from '@lifebit-ai/lds'
import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { extractErrorMessage } from 'core/utils'
import { createDataAccessRequestLabel } from 'services/data-access-requests'
import type { ApiErrorResponse } from 'services/types'
import { isAirlockRequestsV3RoutesEnabled } from 'utils/env'

interface UseCreateDataAccessRequestLabelParams {
  requestId: string
  name: string
}

/** mutation-cache: synced by the caller (useDataAccessRequestDetails onSuccess): label filter, request verification and activity queries */
export const useCreateDataAccessRequestLabel = (
  options?: Omit<UseMutationOptions<void, ApiErrorResponse, UseCreateDataAccessRequestLabelParams>, 'mutationFn'>
) => {
  const toast = useToast()

  return useMutation<void, ApiErrorResponse, UseCreateDataAccessRequestLabelParams>({
    onError: error => {
      toast({ message: extractErrorMessage(error, 'Failed to add label'), type: 'error' })
    },
    ...options,
    mutationFn: params => {
      if (!isAirlockRequestsV3RoutesEnabled()) {
        return Promise.resolve()
      }

      return createDataAccessRequestLabel(params.requestId, params.name)
    }
  })
}
